import { BaseEntity } from "yt-ng-framework";

export class CompanyEmailView extends BaseEntity{
    constructor(){
        super();
    }

    Email:string = null;
    Svojina:string = null;
    Glavni:boolean=null;
    Opis: string = null;


    Deserialize(input:any){
        this.ID=input.ID;
        this.Email=input.Email;
        this.Glavni=input.Glavni;
        this.Svojina=input.Svojina;
        this.Opis=input.Opis;
        return this;
    }

    Serialize(input:CompanyEmailView){
        return input;
    }
}